import React, {FC} from "react"

import RewardWalletBalanceQuery, {RewardWalletBalanceQueryResult} from "@irati/wallet/apollo/query/RewardWallet"
import id from "@irati/utils/id"
import trackingRewardWallet from "@irati-tracking/wallet/rewardWallet"
import TenantWalletBalanceQuery, {TenantWalletBalanceQueryResult} from "@irati/wallet/apollo/query/TenantWallet"
import trackingTenantWallet from "@irati-tracking/wallet/tenantWallet"
import trackingRewardPointsWallet from "@irati-tracking/wallet/rewardPointsWallet"
import {walletTracking} from "@irati-tracking/wallet"
import authentication from "@irati/auth"

import WalletLink from "../shared/WalletLink"
import UserWallet from "../desktop/WalletMenu/UserWallet"

const idNamespace = "mobile-wallet-menu"

const MobileWalletDropdown: FC = () => {
  const showUserCurrencyWallet = authentication.apps("wallet.users")
  const showPerkPoints = authentication.apps("wallet.treatTokens")
  const showRewardWallet = authentication.apps("wallet.rewardWallet")
  const showTenantWallet = authentication.apps("wallet.tenantWallet")
  const showAdminRewardWallet =  authentication.apps("wallet.flexiRewards.canRewardEmployees")
  const tenantName = authentication.userTenant().public_name
  const canTopUp = authentication.apps("wallet.flexiRewards.canTopUpRewardPoints")

  return (
    <>
      {(showUserCurrencyWallet || showPerkPoints) &&
      <UserWallet
        id={idNamespace}
        onClick={() => walletTracking.clickWalletBalance(0, "", "walletDropdown")}
        text="platform.wallet.menu.user.title" />}

      {showRewardWallet && (
        <RewardWalletBalanceQuery useLoader={false}>
          {({data}: RewardWalletBalanceQueryResult) => (
            <WalletLink
              id={id("link-reward-wallet", idNamespace)}
              onClick={trackingRewardWallet.clickRewardWallet}
              text="platform.nav.wallet.reward.mobile.text"
              to="/reward"
              useIcon
              wallet={data.rewardWallet} />
          )}
        </RewardWalletBalanceQuery>
      )}

      {showTenantWallet && (
        <TenantWalletBalanceQuery useLoader={false}>
          {({data}: TenantWalletBalanceQueryResult) => (
            <WalletLink
              id={id("link-tenant-wallet", idNamespace)}
              onClick={trackingTenantWallet.clickTenantWallet}
              text="platform.nav.wallet.tenant.mobile.text"
              tenantName={tenantName}
              to="/tenant"
              useIcon
              wallet={data.tenantWallet} />
          )}
        </TenantWalletBalanceQuery>
      )}

      {showAdminRewardWallet && (
        <WalletLink
          id={id("link-reward-wallet", idNamespace)}
          onClick={() => trackingRewardPointsWallet.clickRewardPointsWallet(canTopUp ? "Admin" : "Manager")}
          text="platform.wallet.menu.flexiRewards.title"
          to="/flexi-reward" />
      )}
    </>
  )
}

export default MobileWalletDropdown
